export default "__VITE_ASSET__DJBjolha__"